import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqCategories } from '../mock';
import Reveal from './Reveal';

const FAQ = () => {
  return (
    <section id="faqs" className="bg-[#262629] px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-[0.9fr_1.4fr] gap-12 lg:gap-20">
        {/* left heading */}
        <Reveal>
          <div className="lg:sticky lg:top-32 self-start">
            <h2 className="font-display text-yellow text-5xl md:text-6xl mb-5">
              Frequently<br />asked<br />questions
            </h2>
            <p className="text-white/75 text-base md:text-lg leading-relaxed mb-8 max-w-md">
              Everything you need to know about our construction estimating service. Can't find the answer you're looking for?
            </p>
            <a
              href="/contact"
              className="inline-block bg-jaw-yellow text-[#262629] font-semibold px-8 py-4 rounded-[10px] hover:bg-[#e8660a] transition-colors"
            >
              Ask us a question
            </a>
          </div>
        </Reveal>

        {/* right accordion grouped by category */}
        <Reveal delay={0.12}>
          <div className="flex flex-col gap-10">
            {faqCategories.map((cat, ci) => (
              <div key={ci}>
                <h3 className="font-display text-white/50 text-sm tracking-[0.2em] uppercase mb-1">
                  {cat.category}
                </h3>
                <Accordion type="single" collapsible className="w-full">
                  {cat.items.map((f, i) => (
                    <AccordionItem
                      key={i}
                      value={`item-${ci}-${i}`}
                      className="border-b border-white/10"
                    >
                      <AccordionTrigger className="py-5 text-left font-display text-white text-lg md:text-xl hover:text-yellow hover:no-underline gap-6 [&>svg]:h-6 [&>svg]:w-6 [&>svg]:shrink-0 [&>svg]:text-yellow">
                        {f.q}
                      </AccordionTrigger>
                      <AccordionContent className="pb-5 text-white/80 text-base md:text-lg leading-relaxed">
                        {f.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
